export default [
  {
    path: '/admin/defines/account-types',
    name: 'AccountTypes',
    component: () => import('@/views/Admin/Defines/Account_types/Index.vue'),
    meta: {
      pageTitle: 'Hesap Tipleri',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/account-types/add',
    name: 'AccountTypeAdd',
    component: () => import('@/views/Admin/Defines/Account_types/Add.vue'),
    meta: {
      pageTitle: 'Hesap Tipleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/account-types',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/account-types/edit/:id',
    name: 'AccountTypeEdit',
    component: () => import('@/views/Admin/Defines/Account_types/Edit.vue'),
    meta: {
      pageTitle: 'Hesap Tipleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/account-types',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
